import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';

import { FinanceFormValues } from '../../../context';

export interface TermButtonHook {
  buttonClassName: string;
}

export default function useTermButton(
  term: number,
  deferred: boolean,
): TermButtonHook {
  const [duration, deferredDuration] = useWatch<
    FinanceFormValues,
    ['duration', 'deferredDuration']
  >({
    name: ['duration', 'deferredDuration'],
  });

  const active = useMemo(
    () => (deferred ? deferredDuration === term : duration === term),
    [deferred, deferredDuration, duration, term],
  );

  const buttonClassName = useMemo(
    () =>
      [
        'w-full px-3 h-[56px] border-2 rounded-lg transition-all flex flex-col justify-center group shadow-md text-14-22-em md:text-16-20-em transition-all',
        active
          ? 'bg-purple-50 border-purple-400 '
          : 'bg-neutral-000 border-neutral-300 hover:border-purple-200',
      ].join(' '),
    [active],
  );

  return {
    buttonClassName,
  };
}
